/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 */

/**
 * Stacking layers that must sit above every dialog, drawer, popover and toast.
 *
 * The app's own scale tops out at the select/dropdown panels (10050-10051);
 * dialogs live at 10000-10003 and the form drawer at 1200. The anti-bot
 * challenge interrupts a save that is usually issued from inside one of those
 * surfaces, so it has to be above all of them -- otherwise the checkbox renders
 * behind the drawer and the user is left staring at a "Saving..." button.
 *
 * A regression test (z-layers.test.ts) scans the source tree and fails if any
 * other layer reaches this value.
 */
export const ANTIBOT_CHALLENGE_Z_INDEX = 10100;
